/**
 * Fetches games from the Google Apps Script backend.
 * @param {string} gasUrl - The deployed GAS web app URL
 * @returns {Promise<{ games: Array, isDemoMode: boolean }>}
 */
import { MOCK_GAMES } from '../data/mockGames';

export async function fetchGames(gasUrl) {
  if (!gasUrl) {
    return { games: MOCK_GAMES, isDemoMode: true };
  }

  let response;
  try {
    response = await fetch(gasUrl);
  } catch (err) {
    throw new Error(`Network error fetching games: ${err.message}`);
  }

  if (!response.ok) {
    throw new Error(`Failed to fetch games: HTTP ${response.status} ${response.statusText}`);
  }

  let json;
  try {
    json = await response.json();
  } catch (err) {
    throw new Error(`Invalid JSON response from games API: ${err.message}`);
  }

  return {
    games:      json.games || [],
    isDemoMode: false,
    updatedAt:  json.updatedAt || null,
    stale:      json.stale    || false,
  };
}

